const Logger = () => {
  // Disabling no-unused-vars rule so that our SSR stub method signatures match the client-side implementation.
  const result = {
    /* eslint-disable no-unused-vars */
    debug: (info) => { },
    error: (...args) => { },
    log: (log) => { },
    warn: (warning) => { },
    /* eslint-enable no-unused-vars */
  };
  if (typeof window === 'undefined') {
    return result;
  }
  const isLocal = window.location.hostname === 'localhost';

  result.debug = (info) => {
    if (isLocal) {
      window.console?.debug?.(info);
    }
  };
  result.error = (...args) => {
    if (isLocal) {
      window.console?.error?.(...args);
      return;
    }
    if (!window.DD_RUM?.addError) {
      return;
    }
    const error = args.find((arg) => arg instanceof Error) ?? args[0];
    if (error !== undefined) {
      window.DD_RUM.addError(error);
    }
  };
  result.log = (log) => {
    if (isLocal) {
      window.console?.log?.(log);
    }
  };
  result.warn = (warning) => {
    if (isLocal) {
      window.console?.warn?.(warning);
    }
  };
  return result;
};

export default Logger();
export { Logger as ComponentUnderTest };
